import { useBoolean, useRequest } from "ahooks";
import { Alert, Button, Checkbox, Input, message, Modal, Tag } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useContext, useEffect, useState } from "react";
import { ButtonPanel } from "../../../../../component/button-panel/button_panel";
import { Mask } from "../../../../../component/mask";
import { Search } from "../../../../../component/search";
import { DataTable } from "../../../../../component/table";
import { TableExpand } from "../../../../../component/table-expand";
import { DataTableStore } from "../../../../../component/table/store/data_table_store";
import { TipsGroup, Tips } from "../../../../../component/tips";
import { defualtPageSize, Progress } from "../../../../../logic/common_logic";

import img_edit from "../../../../assets/images/bianji.png";
import img_see from "../../../../assets/images/chakan1.png";
import img_del from "../../../../assets/images/shanchu.png";
import { fileShopAction } from "../../../action/file/file_shop_action";
import { FileShopStore } from "../../../store/file/file_shop_store";
import { FileShopSearch } from "./shop_search";
import { AuthLogic } from "../../../../../logic/auth_logic";
import { NumberTool } from "../../../../../tool/numberTool";
let editId = "";
let seeId = "";

export function FileShop(viewPower) {
  const [reportState, reportFunc] = useBoolean(false);

  const { state, dispatch } = useContext(FileShopStore);
  const { state: tableState, dispatch: tableDispatch } =
    useContext(DataTableStore);
  const [searchState, searchFunc] = useBoolean(false);

  const action = fileShopAction;
  const [menuButton, setData] = useState([]);
  useEffect(() => {
    (async function () {
      let r = await new AuthLogic().selButton(viewPower.viewPower);
      if (!r) return;
      if (r.length > 0) {
        for (let i = 0; i < r.length; i++) {
          r[i] = r[i].split("_")[r[i].split("_").length - 1];
        }
      }
      setData(r);
    })();

    return () => {};
  }, []);
  const parseTime = (time: string) => {
    if(time && time.split(' ')[0]){
      return  time.split(' ')[0]
    }else{
     return ''
    }
  }
  const columns: ColumnsType = [
    {
      title: "门店名称",
      dataIndex: "shopName",
      key: "2",
      align: "center",
      width: 100
    },
    {
      title: "批次号",
      dataIndex: "storageBatchNumber",
      key: "0",
      align: "center",
      width: 190
    },
    {
      title: "商品编码",
      dataIndex: "goodsNo",
      key: "3",
      align: "center",
      width: 120
    },
    {
      title: "商品名称",
      dataIndex: "goodsName",
      key: "4",
      align: "center",
      width: 120
    },
    {
      title: "商品分类",
      dataIndex: "goodsClass",
      key: "5",
      align: "center",
      width: 120
    },
    {
      title: "库存单位",
      dataIndex: "goodsUnit",
      key: "6",
      align: "center",
      render: (v) => <Tag>{v}</Tag>,
      width: 80
    },
    {
      title: "库存数量",
      dataIndex: "invNumber",
      key: "7",
      align: "center",
      width: 100
    },
    {
      title: "库存价",
      dataIndex: "inventoryPrice",
      key: "8",
      align: "center",
      width: 100
    },
    {
      title: "库存成本",
      key: "8",
      align: "center",
      render: (v, r: any) => (
        <span>
          {(
            (NumberTool.toInteger(r.invNumber).num *
              NumberTool.toInteger(r.averageRate).num) /
            (NumberTool.toInteger(r.invNumber).times *
              NumberTool.toInteger(r.averageRate).times)
          ).toFixed(2)}
        </span>
      ),
      width: 100
    },
    {
      title: "过期时间",
      dataIndex: "expirationDate",
      key: "9",
      align: "center",
      width: 100,
      render:v=><span>{v && parseTime(v)}</span>
    },
  ];

  const onSearch = async (pageIndex) => {
    await action.loadPage({
      pageIndex: pageIndex,
      pageSize: defualtPageSize(),
      dispatch: tableDispatch,
      search: state.search,
      type: 2,
    });
  };

  useRequest(() => action.init({ dispatch }));

  return (
    <>
      <Search>
        <Input
          maxLength={20}
          allowClear
          placeholder="请输入商品编码，名称"
          onChange={(e) =>
            action.setCondition({
              dispatch,
              key: "keywords",
              value: e.target.value,
            })
          }
        />
        <input type="button" value="快速查找" onClick={() => onSearch(1)} />

        <TipsGroup>
          <input
            type="button"
            value="高级查找"
            onClick={() => searchFunc.toggle()}
          />
          <Tips width="45rem" display={searchState}>
            <FileShopSearch
              onSearch={(...arg: [any]) => {
                onSearch(...arg);
                searchFunc.setFalse();
              }}
            />
          </Tips>
          <Mask visible={searchState} onClick={() => searchFunc.setFalse()} />
        </TipsGroup>

        <Checkbox
          onChange={(e) =>
            action.setCondition({
              dispatch,
              key: "iszero",
              value: e.target.checked,
            })
          }
        >
          是否显示库存为0的商品
        </Checkbox>
      </Search>

      <ButtonPanel>
        {menuButton.indexOf("EXPORT") != -1 && (
          <Button
            onClick={async () => {
              await action.exportList({ search: state.search });
            }}
          >
            导出
          </Button>
        )}
      </ButtonPanel>

      <DataTable
        columns={columns}
        action={action}
        onLoad={async () => {
          await onSearch(1);
          Progress.done();
        }}
        onChange={(pageIndex) => {
          onSearch(pageIndex);
        }}
        scroll={{ scrollToFirstRowOnChange: true, autoY: true }}
        selectColumn={false}
        loading={tableState.loading}
      />
      <TableExpand>
        库存数量合计:{" "}
        {tableState.dataList
          .reduce((s, c) => s + Number(c.invNumber), 0)
          .toFixed(3)}
        <span style={{ marginLeft: 10 }}>
          库存成本合计: ¥{" "}
          {tableState.dataList
            .map((r) => Number(r.invNumber) * Number(r.averageRate))
            .reduce((s, c) => s + c, 0)
            .toFixed(2)}
        </span>
      </TableExpand>
    </>
  );
}
